import { handleActions, combineActions } from 'redux-actions';
import { combineReducers } from 'redux';
import * as actionTypes from './system-message-constants';

export const messages = handleActions(
  {
    [actionTypes.SYSTEM_MESSAGE_REQUEST]: () => [],
    [actionTypes.SYSTEM_MESSAGE_SUCCESS]: (state, { payload }) => payload,
  },
  [],
);

export const messageCenterToggled = handleActions(
  {
    [actionTypes.TOGGLE_MESSAGE_CENTER]: (state, { payload }) => payload,
  },
  false,
);

export const error = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.SYSTEM_MESSAGE_REQUEST,
      actionTypes.SYSTEM_MESSAGE_SUCCESS,
      actionTypes.DISCARD_SYSTEM_MESSAGE_REQUEST,
    )]: () => ({}),
    [combineActions(
      actionTypes.SYSTEM_MESSAGE_FAILURE,
      actionTypes.DISCARD_SYSTEM_MESSAGE_FAILURE,
    )]: (state, { payload }) => payload.error,
  },
  {},
);

export const redirectUrl = handleActions(
  {
    [actionTypes.UNLOCK_SYSTEM_MESSAGE_SUCCESS]: (state, { payload }) => payload,
    [combineActions(
      actionTypes.UNLOCK_SYSTEM_MESSAGE_REQUEST,
      actionTypes.UNLOCK_SYSTEM_MESSAGE_FAILURE,
    )]: () => '',
  },
  '',
);

export default combineReducers({
  messages,
  error,
  redirectUrl,
  messageCenterToggled,
});
